// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__22u7X","footer":"ChangeClinic_footer__11Lqv"};